export default __webpack_public_path__ + "75600ea.png";